import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=4b74be76&scoped=true&"
import script from "./PlanItem.vue?vue&type=script&lang=js&"
export * from "./PlanItem.vue?vue&type=script&lang=js&"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=4b74be76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74be76",
  null
  
)

export default component.exports